<template>
  <div
    :id="!hasChildren ? node.dataBaseData.name : ''"
    class="navbar-tree-view"
    :class="{
      'option-enable': !hasChildren,
      active: !hasChildren && node.dataBaseData.name === activeDatabase.name,
      'loading-database':
        !hasChildren && isDatabaseLoading === node.dataBaseData.name,
    }"
    @click="goToDatabase"
  >
    <div
      class="progress-icon"
      v-if="!hasChildren && isDatabaseLoading === node.dataBaseData.name"
    ></div>
    <div
      class="collapsible-icon"
      @click="hasChildren && toggle(node.id)"
      @mouseover="onIconHover"
      :style="{ 'padding-left': 19 + node.index * 20 + 'px' }"
    >
      <!-- <b-icon icon="stack" class="mr-2" v-if="hasChildren"></b-icon>
      <b-icon
        :icon="node.isCollapsed ? 'chevron-down' : 'chevron-right'"
        class="mr-2"
        v-if="hasChildren && !iconView"
      ></b-icon> -->
      <b-icon
        :icon="
          collapsedNodeId.includes(node.id) ? 'chevron-down' : 'chevron-right'
        "
        class="mr-2"
        v-if="hasChildren"
      ></b-icon>
      <span v-if="hasChildren && !iconView" class="database-name">{{
        node.name
      }}</span>
      <div class="left-menu-list" v-if="!hasChildren && !iconView">
        <div class="left-menu-list-name">
          <span class="database-image-wrapper"
            ><img
              :src="
                node.dataBaseData.icon && node.dataBaseData.icon !== 'null'
                  ? node.dataBaseData.url
                  : require('../assets/img/database.svg')
              "
              @click.stop="onDatabaseIconClickPopup"
            />
          </span>
          <a class="database-name">{{ node.name }} </a>
        </div>
        <div class="leftnav-icons-wrap">
          <DropdownComponent
            class="dropdown-btn database-action"
            :currentDatabase="node.dataBaseData"
            :actionOptions="getActionOptions(node.dataBaseData)"
            @onDropDownItemSelect="(type) => getDatabaseOptionMenu(type)"
          />
        </div>
      </div>
      <b-tooltip
        v-if="!hasChildren && !iconView"
        custom-class="rename-tooltip"
        :target="node.dataBaseData.name"
        placement="bottom"
        :show="
          !hasChildren && selectedDatabaseForRename === node.dataBaseData.name
        "
        triggers="none"
      >
        <div class="rename-popup">
          <div class="icon">
            <img
              :src="
                node.dataBaseData.icon && node.dataBaseData.icon !== 'null'
                  ? node.dataBaseData.url
                  : require('../assets/img/database.svg')
              "
            />
          </div>
          <div class="rename-input">
            <input
              type="text"
              autofocus
              ref="renameDatabaseInput"
              v-model="node.dataBaseData.caption"
              @keydown.enter="onRename()"
              @blur="onRename()"
            />
          </div>
        </div>
      </b-tooltip>
    </div>
    <b-collapse
      :id="collapseId"
      v-if="hasChildren && !iconView"
      :visible="collapsedNodeId.includes(node.id)"
    >
      <div class="children">
        <tree-view
          v-for="(child, index) in node.children"
          :key="index"
          :node="child"
          :isDatabaseLoading="isDatabaseLoading"
          :redirect="redirect"
          :activeSection="activeSection"
          :onDatabaseIconClick="onDatabaseIconClick"
          :getActionOptions="getActionOptions"
          :onDropDownItemSelect="onDropDownItemSelect"
          :onDataBaseNameChange="onDataBaseNameChange"
          :activeDatabase="activeDatabase"
          :iconView="iconView"
          @onTreeViewDatabaseRename="onTreeViewDatabaseRename"
          @addTreeCollapseState="addTreeCollapseState"
          :collapsedNodeId="collapsedNodeId"
        />
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { BIcon } from 'bootstrap-vue';
import DropdownComponent from '../components/widgets/DropdownComponent.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'TreeView',
  data() {
    return {
      // isCollapsed: false,
      selectedDatabaseForRename: null,
    };
  },
  components: {
    'b-icon': BIcon,
    TreeView: () => import('./TreeView.vue'), // Recursive import
    DropdownComponent: DropdownComponent,
  },
  props: {
    node: { type: Object, default: {} },
    isDatabaseLoading: { type: String, default: '' },
    activeSection: { type: String, default: '' },
    redirect: { type: Function, default: () => {} },
    onDatabaseIconClick: { type: Function, default: () => {} },
    getActionOptions: { type: Function, default: () => {} },
    onDropDownItemSelect: { type: Function, default: () => {} },
    onDataBaseNameChange: { type: Function, default: () => {} },
    activeDatabase: { type: Object, default: {} },
    iconView: { type: Boolean, default: true },
    collapsedNodeId: { type: Array, default: [] },
  },
  computed: {
    ...mapGetters({ databaseList: 'getDatabaseList' }),
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
    collapseId() {
      // Unique identifier for the collapse element
      return `collapse-${this.node.name}`;
    },
  },
  methods: {
    onIconHover() {
      this.$emit('onIconHover');
    },
    toggle(id) {
      this.$emit('addTreeCollapseState', id);
    },
    goToDatabase(e) {
      if (!this.hasChildren) {
        this.redirect(e, this.activeSection, this.node.dataBaseData.name);
      }
    },
    onDatabaseIconClickPopup(e) {
      this.onDatabaseIconClick(e, this.node.dataBaseData);
    },
    onTreeViewDatabaseRename(IsRenameInProcess) {
      this.$emit('onTreeViewDatabaseRename', IsRenameInProcess);
    },
    addTreeCollapseState(id) {
      this.$emit('addTreeCollapseState', id);
    },
    getDatabaseOptionMenu(type) {
      if (type === 'onRenameDbOptionSelect') {
        this.selectedDatabaseForRename = this.node.dataBaseData.name;
        setTimeout(() => {
          this.$refs['renameDatabaseInput'].focus();
        }, 100);
        this.onTreeViewDatabaseRename(true);
        return;
      }

      const database = this.databaseList?.find(
        (item) => item.name == this.node?.dataBaseData?.name
      );
      this.onDropDownItemSelect(type, database);
    },
    disableToolTip() {
      this.selectedDatabaseForRename = null;
    },
    onRename() {
      try {
        this.onDataBaseNameChange(this.node.dataBaseData);
      } catch (e) {
        console.log(e);
      } finally {
        this.disableToolTip();
        this.onTreeViewDatabaseRename(false);
      }
    },
  },
};
</script>

<style scoped>
.navbar-tree-view {
  position: relative;
  margin-top: 0;
}
.navbar-tree-view .progress-icon {
  content: ' ';
  display: block;
  width: 25px;
  height: 25px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
  margin: 0 auto;
  top: 5px;
  position: absolute;
  left: 46%;
}
@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.navbar-tree-view .left-menu-list {
  display: flex;
  width: 100%;
  margin-left: 0;
  align-items: center;
  justify-content: space-between;
}

.navbar-tree-view .left-menu-list-name {
  display: flex;
  width: 100%;
}

.navbar-tree-view .leftnav-icons-wrap {
  position: absolute;
  padding-left: 10px;
  right: 0;
}
/* .navbar-tree-view:hover .left-menu-list-name {
  max-width: calc(100% - 50px);
} */

.navbar-tree-view:hover .collapsible-icon .left-menu-list-name {
  max-width: calc(100% - 0px);
}

.navbar-tree-view:hover .collapsible-icon:hover .left-menu-list-name {
  max-width: calc(100% - 50px);
}

.option-enable:hover .leftnav-icons-wrap {
  position: relative;
  height: 16px;
  justify-content: center;
  display: flex;
  align-items: center;
  /* background-color: #eeeeee; */
}
.navbar-tree-view .database-image-wrapper img {
  vertical-align: top;
  border-style: none;
  width: 16px;
  margin-right: 12px;
  padding-left: 2px;
  height: 16px;
}

.navbar-tree-view ::v-deep .leftnav-icons-wrap img {
  vertical-align: top;
  border-style: none;
  width: 16px;
  margin-right: 0;
  padding-left: 2px;
  height: 16px;
}

.navbar-tree-view .leftnav-icons-wrap .b-dropdown {
  height: 25px;
  justify-content: flex-end;
}

.navbar-tree-view .database-image-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
}

.navbar-tree-view .dropdown-btn {
  visibility: hidden;
  margin-right: unset;
  /* zoom: 1.1; */
  display: flex;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.option-enable:hover .dropdown-btn {
  visibility: visible;
}

.navbar-tree-view .database-action button {
  padding: 0;
  color: #000;
  width: auto;
  margin-right: 5px;
}

.navbar-tree-view .database-action button:hover {
  color: #000;
}

.rename-tooltip.tooltip.b-tooltip {
  opacity: 1;
}
.rename-popup {
  display: flex;
  width: 380px;
  min-width: 180px;
  max-width: calc(100vw - 24px);
  height: 100%;
  max-height: 70vh;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
}

.rename-tooltip ::v-deep .tooltip-inner {
  border-radius: 4px;
  background: white;
  position: relative;
  max-width: calc(100vw - 24px);
  box-shadow: rgba(15, 15, 15, 0.05) 0px 0px 0px 1px,
    rgba(15, 15, 15, 0.1) 0px 3px 6px, rgba(15, 15, 15, 0.2) 0px 9px 24px;
  overflow: hidden;
  /* position: relative;
  top: 60px;
  left: 16px; */
}

.rename-popup .icon img {
  height: 20px;
}

.rename-popup .icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eee;
}

.rename-popup * {
  box-sizing: border-box;
}
.rename-input input {
  font-size: 14px;
  line-height: 20px;
  padding: 4px 10px;
  border-radius: 3px;
  box-shadow: rgba(15, 15, 15, 0.1) 0px 0px 0px 1px inset;
  background: rgba(242, 241, 238, 0.6);
  width: 100%;
}
.rename-input input:focus {
  outline: none;
  background: rgba(242, 241, 238, 0.6);
}
.rename-popup .rename-input {
  width: calc(100% - 40px);
}

/*New Navbar*/
.nav-left .menu-list-item {
  list-style: none;
  /* padding: 0; */
}

.collapsible-navbar {
  padding: 0 22px 0 30px;
}
.navbar-tree-view {
  transition: all 300ms ease-in-out;
  cursor: pointer;
}

.option-enable:hover {
  background: #eee;
  border-radius: 3px;
}
.loading-database {
  background: #1f2532c7;
}
.navbar-tree-view .collapsible-icon {
  padding-right: 16px;
  /* padding-left: 39px; */
}
.navbar-tree-view ::v-deep .dropdown-menu li a {
  width: auto !important;
}

.navbar-tree-view .collapsible-icon:hover {
  background: #eee;
  border-radius: 3px;
}
.navbar-tree-view .collapsible-icon svg {
  font-size: 15px;
  fill: #333343;
  margin-right: 8px;
}

.navbar-tree-view .children {
  /* margin-left: 20px; */
}

.navbar-tree-view .collapsible-icon span {
  /* font-family: 'AktivGrotesk-Medium'; */
  font-weight: 500;
  color: #333343;
}
.database-action ::v-deep .dropdown-toggle {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-right: 0;
  box-shadow: none;
}

.collapsible-navbar > .navbar-tree-view:last-child {
  padding-bottom: 2px;
}
.navbar-tree-view .collapsible-icon {
  display: flex;
  align-items: center;
  padding-top: 14px;
  padding-bottom: 14px;
}
.active {
  background-color: #f0f0f0;
  border-radius: 3px;
}
.navbar-tree-view .database-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  color: #000000;
  transition: all 500ms ease-in-out;
  font-family: 'AktivGroteskMedium';
  text-decoration: none !important;
  font-weight: 400 !important;
  font-size: 15px !important;
  color: #333343 !important;
  line-height: 15px;
}
</style>
